export enum AGILE_STATIC_TABS {
  DASHBOARD = "5808130c-17c8-4a22-9a14-c2d067ceadf7",
}

export enum SURVEY_STATIC_TABS {
  DASHBOARD = "3972bda4-858c-43de-b4a4-10d84087c723",
}
